// import User from '../../users/vo/User'
// import ChatMessage from '../model/ChatMessage'
// import UpdateRoomCommand from '../model/UpdateRoomCommand'
// import CreateRoomCommand from '../model/CreateRoomCommand'
// import AttachmentMessage from '../model/AttachmentMessage'

export default class ChatMessagingService {

    constructor(chatProvider) {
        this.chatProvider = chatProvider;
    }

    async init(hooks) {
        if (!hooks) throw new Error("Missing required callback hooks when initating the service.");
        await this.chatProvider.init(hooks);
        return true;
    }

    shutdown(){
        this.chatProvider.shutdown()
    }

    getUser() {
        return this.chatProvider.getUser()
    }

    async getAllRoomDescriptors() {
        try {
            if (!this.chatProvider.isInitiated()) throw new Error("Chat service not initiated. Initiate chat by calling the init() method")
            var descPaginator = await this.chatProvider.getChannelDescriptors()
            var descs = descPaginator.items.concat([])
            var currPage = 0
            var maxAllowedPages = 60

            //TODO
            // When I printed out the Paginator into the console, I noticed that there is a "state" object, which in turn holds both "items" and "has next/prev page" markers. 
            // So, maybe, it should be accessed like this :
            // Paginator.state.items
            while (descPaginator.hasNextPage) {
                currPage++
                var pag = descPaginator.nextPage()
                // 1st sign of trouble if items is undefined
                if(!pag.items) break;
                descs = descs.concat(pag.items)
                // 2nd problem, infintity loop avoidance check
                if(currPage >= maxAllowedPages) break;
            }
            return descs
        } catch (error) {
            throw new Error(error)
        }
    }

    async getRoomDescriptorsPaginator() {
        try {
            if (!this.chatProvider.isInitiated()) throw new Error("Chat service not initiated. Initiate chat by calling the init() method")
            var desc = await this.chatProvider.getChannelDescriptors()
            return desc
        } catch (error) {
            throw new Error(error)
        }
    }

    async sendMessage(message) {
        if (!this.chatProvider.isInitiated()) throw new Error("Chat client undefined, initiate chat by calling the init() method")
        var messageId = await this.chatProvider.sendMessage(message)
        return messageId
    }

    async sendAttachmentMessage(message) {
        var messageId = await this.chatProvider.sendAttachment(message)
        return messageId
    }

    async updateRoom(command) {
        var channelName = await this.chatProvider.updateChannelName(command)
        return channelName;
    }

    async createRoom(command) {
        var channelName = await this.chatProvider.createChannel(command);
        return channelName;
    }
}








// WEBPACK FOOTER //
// ./src/platform/chat/services/ChatMessagingService.js